import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer'
import Navbar, { Header, Brand } from 'react-bootstrap/lib/Navbar'
import NavDropdown from 'react-bootstrap/lib/NavDropdown'
import Nav from 'react-bootstrap/lib/Nav'
import NavItem from 'react-bootstrap/lib/NavItem'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import Logo from 'react-icons/lib/ti/flash-outline'

import ChangeSemester from 'components/ChangeSemester'

const TopNav = ({ name, session, currentPath }) => (
  <Navbar staticTop style={{ borderColor: session.get('campus_color') }}>
    <Header style={{ backgroundColor: session.get('campus_color') }}>
      <Brand>
        <Link to="/"><span className="icon"><Logo /></span> <sub>Faculty</sub></Link>
      </Brand>
    </Header>
    <Nav>
      <LinkContainer to="/grades">
        <NavItem>Grading Module</NavItem>
      </LinkContainer>
      <LinkContainer to="/grades-submitted">
        <NavItem>Submitted Grades</NavItem>
      </LinkContainer>
    </Nav>
    <Nav pullRight>
      <ChangeSemester
        session={session}
        currentPath={currentPath}
      />
      <NavDropdown title={name} id="usermenu">
        <LinkContainer to="/account">
          <MenuItem>Change Password</MenuItem>
        </LinkContainer>
        <LinkContainer to="/logout">
          <MenuItem>Log out</MenuItem>
        </LinkContainer>
      </NavDropdown>
    </Nav>
  </Navbar>
)

TopNav.propTypes = {
  name: PropTypes.string,
  session: PropTypes.object,
  currentPath: PropTypes.string,
}

export default TopNav



// WEBPACK FOOTER //
// ./src/partials/TopNav/index.js